<template>
  <v-img src="@/assets/Free consultation.svg" contain width="34" height="34" />
</template>

<script>
  export default {
    name: 'FreeConsultation'
  }
</script>
